/**
 * Main application layout with sidebar navigation
 */

import { Outlet } from 'react-router-dom';
import { Navigation } from './Navigation';

export function AppLayout() {
  return (
    <div className="flex h-screen bg-background">
      {/* Sidebar */}
      <Navigation />

      {/* Main content */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
